import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import SaveUnlocodeSelectionFormContainer from '../containers/SaveUnlocodeSelectionFormContainer';
import Modal from '../../../../core/modules/common/components/Modal';

class SaveUnlocodeSelectionModal extends Component {
  onSubmitSaveSelection = ({ name }) => {
    this.props.saveSelection({
      name,
      checkedUnlocodes: this.props.checkedUnlocodes,
    });
  };

  render() {
    return (
      <Modal
        header={
          <FormattedMessage
            id="app.save.unlocode.selection.form.title"
            tagName="h3"
          />
        }
        closeOnOutsideClick
        onClose={this.props.closeModal}
      >
        <SaveUnlocodeSelectionFormContainer
          onSubmit={this.onSubmitSaveSelection}
          onCloseModal={this.props.closeModal}
          selections={this.props.selections}
          checkedUnlocodes={this.props.checkedUnlocodes}
        />
      </Modal>
    );
  }
}

SaveUnlocodeSelectionModal.propTypes = {
  selections: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    unlocodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  checkedUnlocodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  saveSelection: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default (SaveUnlocodeSelectionModal);
